import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, getToken } from '../asyncConfig';

export const getAllNotifications = createAsyncThunk(
  'notification/getAllNotifications', async (_, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.get(
        `${BASE_URL}/admin/notifications`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.notifications);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getNotificationsFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.notifications = action.payload;
}

export const createNotification = createAsyncThunk(
  'notification/create', async (details, {fulfillWithValue, rejectWithValue}) => {
    try {
      const { data } = await axios.post(
        `${BASE_URL}/admin/notifications`, details,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getNotifications = createAsyncThunk(
  'notification/retrieve', async (channel, {fulfillWithValue, rejectWithValue}) => {
    try {
      const { data } = await axios.post(
        `${BASE_URL}/admin/notifications/retrieve`, {channel},
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.notifications);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)